import { Column } from "./OLTable";

export function calculateCount(filtered?: number, all?: number) {
  if (filtered !== undefined && all !== undefined) {
    return filtered;
  } else if (filtered === undefined && all !== undefined) {
    return all;
  } else if (filtered !== undefined && all === undefined) {
    return filtered;
  } else {
    //fallback for backend not returning any value
    //(hides bugged pagination)
    return 0;
  }
}

export const getColumnsOrdered = ({
  appliedOrdering,
  columns,
}: {
  appliedOrdering: {
    property: string;
    isVisible: boolean;
    isSticky?: boolean;
  }[];
  columns: Column[];
}) => {
  const ordered: any = columns
    .map((column, index) => {
      const orderedIndex = appliedOrdering.findIndex(
        (orderedDetails) => orderedDetails.property === column.property,
      );

      return {
        ...column,
        // take already ordered column or default column order
        orderNo: orderedIndex !== -1 ? orderedIndex : index,
        isVisible:
          orderedIndex !== -1 ? appliedOrdering[orderedIndex].isVisible : true,
        isSticky: appliedOrdering[orderedIndex]?.isSticky,
      };
    })
    .sort((a, b) => a.orderNo - b.orderNo)
    .map((column, idx) => {
      const isStickyFeature = typeof column.isSticky === "boolean";
      return {
        ...column,
        // Set initial sticky column
        isSticky: isStickyFeature ? column.isSticky : idx === 0 ? true : false,
      };
    });
  return ordered;
};
